var app = angular.module("leonardo");

var RuleDeleteDialog = function($scope, FormErrorsService) {
  $scope.rule = $scope.ngDialogData.rule;
  $scope.report = $scope.ngDialogData.report;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.rule.remove().then(function() {
      angular.forEach($scope.report.rules, function(value, key){
        if ($scope.report.rules[key].id == $scope.rule.id) {
          $scope.report.rules.splice(key, 1);
        }
      });
      $scope.confirm($scope.report.rules);
    });
  };
};

app.controller('RuleDeleteDialog', ['$scope', 'FormErrorsService', RuleDeleteDialog]);
